import { useSearchParams } from 'react-router-dom';

export default function OAuthSuccessPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  return (
    <div className="flex items-center justify-center py-16">
      <div className="bg-white rounded-lg shadow-sm p-8 max-w-md mx-auto text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-8 h-8 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Microsoft-Konto verbunden
        </h1>
        <p className="text-gray-600 mb-4">
          Das Microsoft-Konto wurde erfolgreich verknüpft.
        </p>

        {email && (
          <p className="text-sm text-gray-500">
            Verbundenes Konto: <strong>{email}</strong>
          </p>
        )}

        <p className="text-sm text-gray-500 mt-6">
          Sie können dieses Fenster jetzt schließen.
        </p>
      </div>
    </div>
  );
}
